import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import * as dataSourcesCustom from "./dataSourcesCustom.actions";
import {DataSourcesCustomState} from "./dataSourcesCustom";
import {DatasetUsageComponentObject} from '../../classes/dataset-usage-component-object';
import {Serializer} from '../../interfaces/serializer';
import {DataSource} from '../../interfaces/data-source';
import {TypedAction} from '@ngrx/store/src/models';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';
import {
  initializeDataSourcesCustom,
  initializeDataSourcesCustomDimensionsSuccess,
  initializeDataSourcesCustomMetricsSuccess
} from './dataSourcesCustom.actions';
import {MetricComponentObjects} from '../../classes/metric-component-object';
import {CustomImport} from "../../interfaces/custom-import";
import { CustomImportComponentObject } from "../../classes/custom-import-component-object";

const reducer: ActionReducer<DataSourcesCustomState> = createReducer(
  { serialized: [], componentObjects: [], imports: [], customImportComponentObjects: [], importsIncluded: [], loading: false, initialized: false, loaded: false } as DataSourcesCustomState,
  on(dataSourcesCustom.loadDataSourcesCustom, (state: DataSourcesCustomState): DataSourcesCustomState => {
    return { serialized: [], componentObjects: [], imports: [], customImportComponentObjects: [], importsIncluded: [], loading: true, initialized: false, loaded: false };
  }),
  on(dataSourcesCustom.loadDataSourcesCustomSuccess, (state: DataSourcesCustomState, action): DataSourcesCustomState => {
    const customImportComponentObjects: CustomImportComponentObject[] = action.imports.map((item: Serializer<CustomImport>): CustomImportComponentObject => new CustomImportComponentObject(item));

    return {
      serialized: action.dataSources,
      componentObjects: action.dataSources.map((source: Serializer<DataSource>): DatasetUsageComponentObject => new DatasetUsageComponentObject(source, customImportComponentObjects)),
      imports: action.imports,
      customImportComponentObjects: customImportComponentObjects,
      importsIncluded: action.importsIncluded,
      loading: false,
      initialized: false,
      loaded: true
    };
  }),
  on(dataSourcesCustom.updateCustomImport, (state: DataSourcesCustomState): DataSourcesCustomState => {
    return { ...state, loading: true };
  }),
  on(dataSourcesCustom.updateCustomImportSuccess, (state: DataSourcesCustomState, action): DataSourcesCustomState => {
    state.imports.splice(state.imports.findIndex(imp => action.customImport.id === imp.id), 1, action.customImport);
    return { ...state, loading: false };
  }),
  on(dataSourcesCustom.deleteCustomImport, (state: DataSourcesCustomState): DataSourcesCustomState => {
    return { ...state, loading: true };
  }),
  on(dataSourcesCustom.deleteCustomImportSuccess, (state: DataSourcesCustomState, action): DataSourcesCustomState => {
    return {
      ...state,
      imports: state.imports.filter(customImport => customImport.id != action.customImport.id),
      loading: false
    };
  }),
  on(dataSourcesCustom.updateCustomDataSource, (state): DataSourcesCustomState => {
    return { ...state, loading: true };
  }),
  on(dataSourcesCustom.updateCustomDataSourceSuccess, (state: DataSourcesCustomState, action): DataSourcesCustomState => {
    state.serialized.splice(state.serialized.findIndex(data => action.dataSource.id === data.id), 1, action.dataSource);

    const componentObject: DatasetUsageComponentObject = state.componentObjects.find((item: DatasetUsageComponentObject): boolean => item.payload.id === action.dataSource.id);
    if (componentObject) {
      componentObject.update(action.dataSource);
    }

    return { ...state, loading: false };
  }),
  on(initializeDataSourcesCustom, (state: DataSourcesCustomState): DataSourcesCustomState => {
    return {
      ...state,
      initialized: false
    };
  }),
  on(initializeDataSourcesCustomDimensionsSuccess, (state: DataSourcesCustomState, action: TypedAction<string> & { dimensions: DimensionComponentObjects, generalDimensions: DimensionComponentObjects }): DataSourcesCustomState => {
    state.componentObjects.forEach((componentObject: DatasetUsageComponentObject): void => componentObject.initDimensions(action.dimensions, action.generalDimensions));
    state.customImportComponentObjects.forEach((customImport: CustomImportComponentObject): void => customImport.initDimensions(action.generalDimensions, action.dimensions));

    return {
      ...state,
      initialized: true
    };
  }),
  on(initializeDataSourcesCustomMetricsSuccess, (state: DataSourcesCustomState, action: TypedAction<string> & { metrics: MetricComponentObjects }): DataSourcesCustomState => {
    state.componentObjects.forEach((componentObject: DatasetUsageComponentObject): void => componentObject.initMetrics(action.metrics));
    state.customImportComponentObjects.forEach((customImport: CustomImportComponentObject): void => customImport.initMetrics(action.metrics));

    return {
      ...state,
      initialized: true
    };
  })
);

export const dataSourcesCustomReducer: ActionReducer<DataSourcesCustomState> = (state: DataSourcesCustomState, action: Action) => {
  return reducer(state, action);
};
